import { render, staticRenderFns } from "./endPlaceholder-editor.vue?vue&type=template&id=fa69db96&scoped=true"
import script from "./endPlaceholder-editor.vue?vue&type=script&lang=js"
export * from "./endPlaceholder-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa69db96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa69db96')) {
      api.createRecord('fa69db96', component.options)
    } else {
      api.reload('fa69db96', component.options)
    }
    module.hot.accept("./endPlaceholder-editor.vue?vue&type=template&id=fa69db96&scoped=true", function () {
      api.rerender('fa69db96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/endPlaceholder-editor.vue"
export default component.exports